"use client";

import CancellationPolicyView from "@/views/CancellationPolicy";

export default function CancellationPolicyPage() {
  return <CancellationPolicyView />;
}
